import { render, staticRenderFns } from "./BatchesIndex.vue?vue&type=template&id=00bb3588&scoped=true"
import script from "./BatchesIndex.vue?vue&type=script&lang=ts"
export * from "./BatchesIndex.vue?vue&type=script&lang=ts"
import style0 from "./BatchesIndex.vue?vue&type=style&index=0&id=00bb3588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb3588",
  null
  
)

export default component.exports